//noinspection JSValidateTypes
export default angular.module("rangeFilter", [])
  .filter("range", rangeFilter)
  .name;

const $inject = [];

function rangeFilter() {
  return function (end, start = 1, step = 1) {
    step = step || 1;
    let arr = [];
    if (step > 0) {
      for (let i = start; i <= end; i += step) {
        arr.push(i);
      }
    }
    else {
      for (let i = start; i >= end; i += step) {
        arr.push(i);
      }
    }
    return arr;
  };
}

rangeFilter.$inject = $inject;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/filters/range.filter.js
 **/